<template>
  <div>
    <div :dependentComputedProps="{ appConfig }"></div>

    <div
      class="user-address-header"
      @click="handleAddressEdit($event)" 
      :class="{ hide: !getCurrentStoreFolder }"
    >
      <i class="jfi-location fs-13"></i>
      <span class="address-alias lh18 bold ml5 mr8 fs-14">{{
        locationData.address_alias || "No Location"
      }}</span>
      <i class="jfi-arrow-line"></i>
      <span class="complete-address lh18">{{
        isTrueLocationDetected
          ? locationData.complete_address
          : isNearestStoreApiSuccess
          ? nearestStoreRequiredData
          : "Select location to find the nearest store"
      }}</span>
    </div>

    <!-- Modal fetching location animation -->
    <generic-modal
      v-if="isLocationLoading"
      :height="settingLocationModalDim.height"
      :width="settingLocationModalDim.width"
      :padding="settingLocationModalDim.padding"
      :modalClass="settingLocationModalDim.modalClass"
      :zIndex="
        vwoVariant === 'nextgen_variant_g' || vwoVariant === 'nextgen_variant_h'
          ? '9999'
          : ''
      "
    >
      <template v-slot:header>
        <div class="setting-user-address">
          <VueLottiePlayer
            name="offerIconAnim"
            width="100%"
            height="100%"
            loop
            :animationData="
              require('../assets/setting-location-animation.json')
            "
          />
        </div>
      </template>
      <template v-slot:body>
        <shimmer></shimmer>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>

    <!-- Modal while intial session is created -->
    <generic-modal
      v-if="!isSessionPresent"
      :height="locationLoaderModalDim.height"
      :width="locationLoaderModalDim.width"
      :modalClass="locationLoaderModalDim.modalClass"
    >
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body> </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>

    <!-- Location permission popup -->
    <generic-modal
      v-if="showLocationPermissionModal"
      :height="menuModalDim.height"
      :width="menuModalDim.width"
      :modalClass="menuModalDim.modalClass"
      :zIndex="vwoVariant === 'nextgen_variant_h' ? '9999' : ''"
      :genericModalSource="'showLocationPermissionModal'"
    >
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <div class="flex-column location-permission-div">
          <i class="jfi-location fs-14 color-dark-green"></i>
          <p class="fs-14 tc">
            Allow <b class="bold">Domino's</b> to access this <br />
            device's location ?
          </p>
          <div class="disp-col-inline jcsb full mt20">
            <span
              class="text-cta"
              @click="handleLocationPermissionModal(false , true)"
            >
              Ask Later
            </span>
            <button
              class="btn medium"
              @click="handleLocationPermissionModal(true , true)"
            >
              Allow
            </button>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>

    <!--  Modal Location fetched animation -->
    <!--     <generic-modal
      v-if="showLocationFetchedPopup"
      :height="locationLoaderModalDim.height"
      :width="locationLoaderModalDim.width"
      :modalClass="locationLoaderModalDim.modalClass"
    >
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <div class="setting-location move-effect lft-pos">
          <div>
            <i class="jfi-location fs-52 loc-ico-effect"></i>
            <div
              class="addr-alias bold fs-18 color-primary font-dec-effect-14 tl pl15"
            >
              {{ isTrueLocationDetected ? locationData.address_alias : "..." }}
            </div>
          </div>
          <div class="addr-complete fs-14 color-base font-dec-effect-12">
            {{
              isTrueLocationDetected
                ? locationData.complete_address
                : "Exact location required!"
            }}
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal> -->
    <template v-if="showLocationAccessBlockedModal">
      <location-access-blocked-message></location-access-blocked-message>
    </template>

    <!-- Login modal -->
    <generic-modal
      v-if="showLoginModal"
      @close="closeLoginModal()"
      :height="loginModalDim.height"
      :width="loginModalDim.width"
      :modalClass="loginModalDim.modalClass"
      :genericModalSource="'homeLoginIcon'"
    >
      <template v-slot:header>
        <!-- <i @click="closeSearchModal()" class="jfi-cross sticky-pop-cross"></i> -->
      </template>
      <template v-slot:body>
        <div class="login-modal">
          <div class="login-top">
            <Carousel
              :autoplay="3000"
              :wrap-around="true"
              :pauseAutoplayOnHover="true"
              :mouseDrag="false"
              :touchDrag="false"
              :transition="900"
              :items-to-show="1"
            >
              <Slide v-for="(data, index) in loginModalData" :key="index">
                <div class="login-nudge-img pr">
                  <template v-if="data.imageUrl">
                    <lazy-image
                      :src="staticImgBaseUrl + '/images/global' + data.imageUrl"
                      alt="Login Nudge image"
                    />
                  </template>
                  <div class="dot-flashing-container">
                    <div
                      class="dot-flashing"
                      :class="{ 'active-slide-dot': i == index }"
                      v-for="(m, i) in loginModalData"
                      :key="i"
                    ></div>
                  </div>
                  <div class="domino-logo-img">
                    <lazy-image
                      :src="
                        staticImgBaseUrl + '/images/global' + loginModuleIcon
                      "
                      alt="Domino logo image"
                    />
                  </div>
                </div>
                <div class="login-nudge-desc bold" v-html="data.desc"></div>
              </Slide>
              <template #addons> </template>
            </Carousel>
          </div>
          <div class="login-bottom tc">
            <button class="btn login-cta" @click="gotoLogin()">Login</button
            ><br />
            <span class="color-grey fs-12 mt5" @click="closeLoginModal()"
              >Skip Login</span
            >
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>

    <login-nudge-modal-small
      v-if="
        shouldHideCompleteLoginFlow
          ? false
          : shouldHideLoginPopupVariant || shouldHideLocationAndLoginFlowVariant
          ? false
          : shouldHideLocationPermissionPopupVariant //only hide location flow but show login
          ? true
          : shouldHideCompleteLocationFlow 
          ? true 
          : isLocationSettled
      "
    ></login-nudge-modal-small>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>

<script>
import { defineAsyncComponent } from "vue";
import GenericModal from "./GenericModal.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { keyMapsMutation, keyMapsAction, keyMapsGetter } from "../helpers/storeKeys";
import { getExperimentsPromiseArray } from "../helpers/vwoSetup";
import {
  staticImgBaseUrl,
  projectBasePathWithFolder,
  v2PwaBasePath,
  shouldHideCompleteLocationFlow,
  shouldHideCompleteLoginFlow,
  shouldLoginFlowSkip
} from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import LoginNudgeModalData from "../assets/FallbackData/LoginNudgeModalData.json";
import setEvents, { loadAmplitudeUnsentEvents } from "../helpers/events";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
  VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME,
} from "../config/vwoKeys";
import userActivityTracking from "../helpers/UserActivityTracking";
import PageNames from "../config/pageNames";
import Shimmer from "./Shimmer.vue";
import { initializeMoEngageTime } from "../helpers/moengage";
import amplitude from "amplitude-js";
export default {
  name: "HomePageUserAddress",

  components: {
    GenericModal,
    LocationAccessBlockedMessage: defineAsyncComponent(() =>
      import("./LocationAccessBlockedMessage.vue")
    ),
    Carousel,
    Slide,
    LoginNudgeModalSmall: defineAsyncComponent(() =>
      import("./LoginNudgeModalSmall.vue")
    ),
    Shimmer,
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
  },

  data() {
    return {
      showMenuModal: false,
      menuModalDim: {
        width: "270px",
        height: "fit-content",
        modalClass: "top-40per",
      },
      staticImgBaseUrl: staticImgBaseUrl,
      showLocationLoadingPopup: false,
      /* showLocationFetchedPopup: false, */
      showLocationPermissionModal: false,
      isOnStorePage: window.location.href.includes(
        Utility.getCurrentStoreFolder()
      ),
      locationLoaderModalDim: {
        width: "100vw",
        height: "100vh",
        modalClass: "full-screen-popup search-modal-wrap",
      },
      settingLocationModalDim: {
        width: "100vw",
        height: "100vh",
        padding: "0px",
        modalClass: "shimmer-location-modal",
      },
      showLoginModal: false,
      loginModalDim: {
        width: "100vw",
        height: "100vh",
        modalClass: "full-screen-popup login-modal-wrap",
      },
      loginModalData: [],
      loginModuleIcon: "",
      amplitudeTimeSpentIsNotProcessed: true,
      shouldHideCompleteLoginFlow,
    };
  },

  async mounted() {
    let isVwoVariantAvailable = true;
    let vwoVariant = "";

    //encrypting data for old user
    let dataToEncrypt = LocalStorageFunc.getUserData()?.userData;
    let encryptedData = "";

    if(dataToEncrypt && typeof(dataToEncrypt) === "object"){
      encryptedData = Utility.encryptData(dataToEncrypt);
    let userInfo = LocalStorageFunc.getUserData();
    userInfo.userData = encryptedData;
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    }

    let dataToEncryptForAddress  = LocalStorageFunc.getAddressDetail();
    let encryptedDataForAdress = "";

    if(dataToEncryptForAddress && typeof(dataToEncryptForAddress) === "object"){
      encryptedDataForAdress = Utility.encryptData(dataToEncryptForAddress);
      LocalStorageFunc.setAddressDetail(encryptedDataForAdress);
    }

    await Promise.all([...getExperimentsPromiseArray()])
      .then((data) => {
        let __ = document.getElementsByClassName("pg-wrapper");
        if (__?.length > 0) {
          let ___ = {};

          data.forEach((element) => {
            for (let key in element) {
              if (key && element[key]) {
                __[0].classList.add(`${key}-${element[key]}`);
              }
              ___[key] = element[key];
            }
          });

          if (
            !Utility.checkNextgenVariant(___[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT])
          ) {
            isVwoVariantAvailable = false;
            LocalStorageFunc.unsetSessionStorageKey("nextgenhomepage");
            window.location.href = v2PwaBasePath + Utility.getUrlQueryString();
            return;
          }
          vwoVariant = ___[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
          this.$store.commit(keyMapsMutation.UPDATE_VWO_EXPERIMENTS, ___);
        }
      })
      .catch((errors) => {});
    Utility.initializeUtmAttributes();
    loadAmplitudeUnsentEvents(vwoVariant);

    let exp = this.$store.state.Config.vwoExperiments;
    if (Utility.checkNextgenVariant(exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT])) {
      setEvents("amplitude", "pageView", {
        [VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME]:
          exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT],
        Page_Name: PageNames.NEXTGEN_HOMEPAGE,
        Previous_page: document.referrer,
      });
      setEvents("amplitude", "nextgenPwaAb", {
        [VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME]:
          exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT],
      });

      let landingPage = Utility.tryJsonParse(
        sessionStorage.LANDING_PAGE_FOR_NEXTGEN
      );
      if (landingPage == "/") {
        landingPage = "home";
      }
      try {
        landingPage =
          landingPage?.trim()?.replace(/^\/+/, "")?.replace(/\/+$/, "") ||
          "home";
      } catch (e) {
        landingPage = "home";
      }
      setEvents("amplitude", "nghUserURL", {
        Page_Name: PageNames.NEXTGEN_HOMEPAGE,
        Previous_page: document.referrer,
        url: window.location.href,
        landingPage: landingPage,
      });
    }

    let linkRewrite = Utility.getLinkRewriteFromSiteprops();
    if(linkRewrite === PageNames.NEXTGEN_LINKREWRITE_HOME && Utility.getNoRedirectFromWindow()) {
      LocalStorageFunc.setSessionStorageKey('previousLinkRewrite', linkRewrite);
    }
    if(linkRewrite !== PageNames.NEXTGEN_LINKREWRITE_HOME) {
      LocalStorageFunc.unsetSessionStorageKey('previousLinkRewrite');
    }

    this.hidePageLoader();
    if (!window.location.href.split("?")[0].includes(Utility.getCurrentStoreFolder())) {
      window.location.href =
        projectBasePathWithFolder +
        Utility.getCurrentStoreFolder() +
        LocalStorageFunc.storeId() +
        Utility.getUrlQueryString();
      return;
    }
    //this.checkShowLoginModal();
    /*     if (LocalStorageFunc.isMiniAppPaytmGpay()) {
      LocalStorageFunc.unsetSessionStorageKey("nextgenhomepage");
      window.location.href =
        v2PwaBasePath + "?utm_source=" + LocalStorageFunc.isMiniAppPaytmGpay();
    } else {
      localStorageFunc.setNextGenKeyInSession();
    } */

    if (isVwoVariantAvailable) {
      LocalStorageFunc.setNextGenKeyInSession();
    }

    /* this.locationAnimation(); */
    this.loginModalData = LoginNudgeModalData?.data
      ? LoginNudgeModalData?.data
      : [];
    this.loginModuleIcon = LoginNudgeModalData?.logoUrl
      ? LoginNudgeModalData?.logoUrl
      : "";
    window.addEventListener("online", function () {
      // console.log("online");
    });
    window.addEventListener("offline", function () {
      // console.log("offline");
    });

    this.startupAppiCallsWrapper(() => {
      if (
        !LocalStorageFunc.isLoggedIn() &&
        !LocalStorageFunc.getSessionStorageValuePwaV2Keys("LOGIN_FLOW_SKIP") &&
        shouldLoginFlowSkip
      ) {
        const loginPageUrl = `/${window?._siteProps_?.props?.postorderUIBasepath}login`;
        window.location.href =
          `${v2PwaBasePath}${loginPageUrl}` + Utility.getUrlQueryString();
      } else {
        if (!LocalStorageFunc.cartId()) {
          this.$store.dispatch(keyMapsAction.ANONYMOUS_USER_API, {
            startupAppiCalls: () => {
              this.startupAppiCalls();
            },
          });
        } else {
          this.startupAppiCalls();
        }
      }
    });
    this.scrollToCategoryId();

    Utility.pizzaCounter();
    setTimeout(() => {
      initializeMoEngageTime();
    }, 5000);
    this.$store.dispatch(keyMapsAction.PIZZA_TOPPING_API, {}, { root: true });

    if("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }
    window.addEventListener('popstate', function(event) {
      if(window.scrollY !== 0){
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        })
        history.pushState(null,null, window.location.href)
      } else {
        history.back();
      }
    });
    history.pushState(null,null, window.location.href);
  },

  methods: {
    isMenuSequencingEnabled() {
      return window?._siteProps_?.props?.enableMenuSequencing === "true";
    },
    scrollToCategoryId() {
      let queryParams = Utility.getQueryFromUrl();
      const menuCategory = queryParams["scrollTo"] 
                            || queryParams["cat_id"]
                            || queryParams["categoryId"]
                            || "";
      if (menuCategory !== "") {
        setTimeout(() => {
          if (menuCategory === "menuTop") {
            Utility.scrollUptoMenuTop();
          } else {
            Utility.scrollUptoTo("element_catg_" + menuCategory);
          }
        }, 0);
      }
      // removed for NGH-1938
      // else {
      //   Utility.scrollToFromSessionKey(); 
      // }
    },
    eventFunction(isClicked = false, eObj = "" , popUpVisible=false , popUpVisibleVal="") {
      let eventType = isClicked ? "Click" : "Impression";
      let userAction = isClicked ? "click" : "impression";
      let preEventObj = {
        ...eObj,
      };

      if(popUpVisible){
        userAction = popUpVisibleVal ? 'allow': 'ask later';
        const eventObj = Utility.amplitudeEventObj(
          userAction,
          undefined,
          undefined,
          preEventObj
        );
        setEvents("amplitude", 'location_permission_on_home', eventObj);
      }
      else{
        preEventObj["loginStatus"] = this.isLoggedIn ? "yes" : "no";   

        const eventObj = Utility.amplitudeEventObj(
          userAction,
          "topbar",
          "1",
          preEventObj
        );
        setEvents("amplitude", eventType, eventObj);
      }
    },
    hidePageLoader() {
      document.getElementById("pageLoader").style.display = "none";
    },
    checkShowLoginModal() {
      var loginSkippedStatus = Utility.getCookie("Login_skipped");
      LocalStorageFunc.isLoggedIn()
        ? ((this.showLoginModal = false),
          userActivityTracking.pageView(0, "homePageViewed"),
          userActivityTracking.loginStatus(0))
        : loginSkippedStatus == "true"
        ? (this.showLoginModal = false)
        : (this.showLoginModal = true);
      return this.showLoginModal;
    },
    /*     locationAnimation() {
      if (
        window.location.href.includes(Utility.getCurrentStoreFolder()) &&
        !window.location.href.includes(
          Utility.getCurrentStoreFolder() + Location.defaultStoreId
        ) &&
        !LocalStorageFunc.getLocationAnimationKey()
      ) {
        LocalStorageFunc.setLocationAnimationKey(true);
        this.showLocationFetchedPopup = true;
      }
      setTimeout(this.closeLocationFetchedPopup, 1600);
    }, */
    /*     closeLocationFetchedPopup() {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showLocationFetchedPopup = false;
    }, */
    handleAddressEdit() {
      this.eventFunction(true, {
        category: "location",
        subCategory: "location",
      });
      userActivityTracking.location(0);
      let deliveryType = LocalStorageFunc.getDeliveryType();
      let redirectUrl = `${window?._siteProps_?.props?.postorderUIBasepath}searchAddress?deliveryType=${deliveryType}`;
      if (Utility.checkIfOrderTypeNonDelivery(deliveryType)) {
        redirectUrl = Utility.redirectUrlForNonDeliveryOrderType(
          this.isTrueLocationDetected,
          deliveryType
        );
      }
      window.location.href = `${v2PwaBasePath}/${redirectUrl}&isFromHome=true`;
    },
    startupAppiCallsWrapper(inputFunc) {
      if (navigator.permissions) {
        navigator.permissions
          .query({ name: "geolocation" })
          .then(function (PermissionStatus) {
            if (PermissionStatus.state == "granted") {
              LocalStorageFunc.setIsLocationPermissionGiven();
              //console.log("allowed")
            } else if (PermissionStatus.state == "prompt") {
              //console.log("prompt");
            } else {
              //console.log("denied");
            }
            inputFunc();
          });
      } else {
        inputFunc();
      }
    },
    locationCalls() {
      if (window.location.href.includes(Utility.getCurrentStoreFolder())) {
        let payload = LocalStorageFunc.getCoordsFromRecentLocation();
        if (payload) {
          payload.source = LocalStorageFunc.getLocationSource();
        }
        if (
          LocalStorageFunc.getDeliveryType() != "D" &&
          LocalStorageFunc.getCoordsForTakeaway()
        ) {
          this.$store.dispatch(
            keyMapsAction.GEO_CODE_API_COMBO,
            LocalStorageFunc.getCoordsForTakeaway()
          );
        } else if (payload?.source == "ip") {
          if (LocalStorageFunc.getHideLocationPopupOnceFromSession()) {
            this.$store.dispatch(keyMapsAction.GOOGLE_GEO_LOCATION_API, {});
            LocalStorageFunc.unsetSessionStorageKey("hideLocationPopupOnce");
          } else {
            this.showLocationPermissionModal = true;
            if (LocalStorageFunc.getIsLocationPermisssionGiven()) {
              this.handleLocationPermissionModal(true);
            } else if (LocalStorageFunc.getAskLocationLaterFromSession()) {
              this.handleLocationPermissionModal(false);
            }
          }
        } else if (
          payload?.coords?.latitude &&
          LocalStorageFunc.isLocationSelectedFromPwaV2()
        ) {
          this.$store.dispatch(keyMapsAction.GEO_CODE_API_COMBO, payload);
        } else {
          if (!shouldHideCompleteLocationFlow &&
              !this.shouldHideLocationPermissionPopupVariant &&
              !this.shouldHideLocationAndLoginFlowVariant
              ) {
            if(payload?.coords) {
              this.$store.dispatch(keyMapsAction.LOAD_RECENT_LOCATION_FROM_LOCAL_STORAGE);
              return;
            }
            this.showLocationPermissionModal = true;
            if (LocalStorageFunc.getIsLocationPermisssionGiven()) {
              this.handleLocationPermissionModal(true);
            } else if (LocalStorageFunc.getAskLocationLaterFromSession()) {
              this.handleLocationPermissionModal(false);
            }
          } else {
            this.$store.dispatch(keyMapsAction.LOAD_RECENT_LOCATION_FROM_LOCAL_STORAGE);
          }
        }
      } else {
        window.location.href =
          projectBasePathWithFolder +
          Utility.getCurrentStoreFolder() +
          LocalStorageFunc.storeId() +
          Utility.getUrlQueryString();
      }
    },
    startupAppiCalls() {
      /*       if (this.checkShowLoginModal()) {
        return;
      } */
      this.$store.dispatch(keyMapsAction.LOAD_LOGIN_STATUS, {});
      this.$store.commit(keyMapsMutation.LOAD_CURRENT_ORDER_TYPE, {});
      if (Utility.isStoreUrlCacheEligible()) {
        this.$store.commit(keyMapsMutation.UPDATE_IS_LOCATION_SETTLED, {});
        let payload = LocalStorageFunc.getCoordsFromRecentLocation();
        this.$store.dispatch(keyMapsAction.CACHED_STORE_API, payload);
      } else {
        this.locationCalls();
      }
      LocalStorageFunc.isLoggedIn() &&
        this.$store.dispatch(keyMapsAction.LOYALITY_API);
      LocalStorageFunc.isLoggedIn() &&
        this.$store.dispatch(keyMapsAction.WALLET_BALANCE_API);
      this.$store.dispatch(keyMapsAction.WELCOME_OFFER_API, {});
      this.$store
        .dispatch(keyMapsAction.PERSONALIZATION_API, {})
        .then(() => {
          this.$store.commit(
            keyMapsMutation.UPDATE_CART_FROM_LOCAL_STORAGE,
            this.$store.state.ProductItems.unfilteredProductItems
          );
        });

      let exp = this.$store.state.Config.vwoExperiments;
      if (
        this.isMenuSequencingEnabled() &&
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_R
      ) {
        this.$store.dispatch(keyMapsAction.MENU_SEQUENCING_API, {});
      }

      /* this.$store.dispatch(keyMapsAction.LEFT_MENU_API, {}); */
      LocalStorageFunc.getGetOfferSuccess()?.welcomeOfferGetStatus !==
        undefined &&
        this.$store.commit(keyMapsMutation.UPDATE_OFFER_APPLY_RESPONSE, {
          welcomeOfferGetStatus:
            LocalStorageFunc.getGetOfferSuccess().welcomeOfferGetStatus,
        });
    },
    handleLocationPermissionModal(value , popUpVisible = false) {
      this.showLocationLoadingPopup = true;
      if (value) {
        this.$store.dispatch(keyMapsAction.DETECT_GEO_LOCATION_POPUP, {
          source: "locationPopup",
          showModalM: () => this.showModalM(),
        });
      } else {
        LocalStorageFunc.setAskLocationLaterInSession();
        this.$store.dispatch(keyMapsAction.GOOGLE_GEO_LOCATION_API, {});
      }
      this.showLocationPermissionModal = false;
      if(popUpVisible){
        if(value){
          this.eventFunction(true, {
        eventCategory: "location permission on home screen",
      }, true , value);
        }else{
          this.eventFunction(true, {
        eventCategory: "location permission on home screen",
      }, true , value);
        }
      }

    },
    showModalM() {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_LOCATION_ACCESS_BLOCKED_MODAL,
        true
      );
      if(shouldHideCompleteLocationFlow) {
        this.showLocationLoadingPopup = false;
      }
    },
    closeLoginModal() {
      let domain = Utility.getDomain();
      Utility.setCookie("Login_skipped", true, 1, domain);
      if (window.location.href.includes(Utility.getCurrentStoreFolder())) {
        window.location.reload();
      } else {
        window.location.href =
          projectBasePathWithFolder +
          Utility.getCurrentStoreFolder() +
          LocalStorageFunc.storeId() +
          Utility.getUrlQueryString();
      }
      userActivityTracking.pageView(0, "homePageViewed");
      userActivityTracking.loginStatus(0);
    },
    gotoLogin() {
      window.location.href = `${v2PwaBasePath}/postorder-ui/login`;
    },
    getTimeSpentEventFireTime() {
      return ((window?._siteProps_?.props?.amplitudeTimeSpentEventFireTime) ? (window?._siteProps_?.props?.amplitudeTimeSpentEventFireTime) : "3");
    },
  },
  computed: {
    appConfig() {
      if (this.amplitudeTimeSpentIsNotProcessed) {
        this.amplitudeTimeSpentIsNotProcessed = false;
        let eventFireTime = this.getTimeSpentEventFireTime();
        setTimeout(() => {
          setEvents("amplitude", "time_spent", {
            eventCategory: 'time spent',
            fired_after: eventFireTime,
            Events_time_stamp: new Date().getTime(),
            Page_Name: PageNames.NEXTGEN_HOMEPAGE
          });
        }, eventFireTime * 1000); //time in milliseconds
      }
    },
    showLocationAccessBlockedModal() {
      return this.$store.state.Location.showLocationAccessBlockedModal;
    },
    isLoggedIn() {
      return this.$store.state.Auth.isLoggedIn;
    },
    isSessionPresent() {
      let _ =
        this.$store.state.Auth.isLoggedIn ||
        this.$store.state.Auth.isSessionPresent;
      return _;
    },
    locationData() {
      return this.$store.state.Location.locationData;
    },
    isTrueLocationDetected() {
      return this.$store.state.Location.isTrueLocationDetected;
    },
    currentOrderType() {
      return this.$store.state.User.currentOrderType;
    },
    storeNotFound() {
      return this.$store.state.Location.storeNotFound;
    },
    isLocationSettled() {
      return this.$store.state.Location.isLocationSettled;
    },
    vwoVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      return exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
    },
    isNearestStoreApiSuccess() {
      return this.$store.state.Location.isNearestApiSuccessful;
    },
    nearestStoreRequiredData() {
      let data = this.$store.state.Location.nearestApiRequiredData;
      if (data !== undefined && data !== null) return data;
      else return "Select location to find the nearest store";
    },
    hideLocationLoadingPopup() {
      this.showLocationLoadingPopup = false;
    },
    isLocationLoading() {
      return shouldHideCompleteLocationFlow
        ? this.$store.state.Location.showLocationLoading
        : !this.isLocationSettled &&
            this.showLocationLoadingPopup &&
            !Utility.isStoreUrlCacheEligible();
    },
    shouldHideLocationPermissionPopupVariant() {
      //only hide location flow but show login
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_H
      ) {
        return true;
      } else {
        return false;
      }
    },
    shouldHideLoginPopupVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_G
      ) {
        return true;
      } else {
        return false;
      }
    },
    shouldHideLocationAndLoginFlowVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_I
      ) {
        return true;
      } else {
        return false;
      }
    },
    getCurrentStoreFolder() {
      let exp = this.$store.getters[keyMapsGetter.GET_CURRENT_STORE_FOLDER_CONFIG];
      return window.location.href.includes(exp);
    }
  },
};
</script>

<style scoped></style>
